import clsx from 'clsx'
import { useState } from 'react'

interface AvatarProps {
  src?: string | null
  name?: string
  size?: 'sm' | 'md' | 'lg' | 'xl'
  fallbackEmoji?: string
  className?: string
}

const sizes = {
  sm: 'w-8 h-8 text-sm',
  md: 'w-10 h-10 text-lg',
  lg: 'w-12 h-12 text-xl',
  xl: 'w-16 h-16 text-2xl',
}

function getInitials(name?: string): string {
  if (!name) return ''
  const parts = name.trim().split(/\s+/).filter(Boolean)
  if (parts.length >= 2) {
    return (parts[0][0] + parts[1][0]).toUpperCase()
  }
  return (parts[0] || '').slice(0, 2).toUpperCase()
}

export default function Avatar({
  src,
  name,
  size = 'md',
  fallbackEmoji,
  className,
}: AvatarProps) {
  const [failedSrc, setFailedSrc] = useState<string | null>(null)
  const initials = getInitials(name)

  if (src && src !== failedSrc) {
    return (
      <img
        src={src}
        alt={name || 'Avatar'}
        onError={() => setFailedSrc(src)}
        className={clsx(
          'rounded-full object-cover',
          sizes[size],
          className
        )}
      />
    )
  }

  return (
    <div
      className={clsx(
        'rounded-full bg-tg-button/20 flex items-center justify-center font-medium text-tg-button',
        sizes[size],
        className
      )}
    >
      {fallbackEmoji || initials || '?'}
    </div>
  )
}
